import { Component, OnInit } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ApiService } from 'src/app/api.service';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/_services';
import { SecurityDocument } from 'src/app/shared/models/SecurityDocument';
import * as FileSaver from 'file-saver';
import autoTable from 'jspdf-autotable'
import { TranslateRelLabelVO } from 'src/app/shared/models/TranslateRelLabelVO';
import { Form0WrpVO } from 'src/app/shared/models/Form0WrpVO';
import { SchoolFpgVO } from 'src/app/shared/models/SchoolFpgVO';
import { SchoolFpgDataVO } from 'src/app/shared/models/SchoolFPGDataVO';
import { SchoolFPGWrpVO } from 'src/app/shared/models/SchoolFPGWrpVO';
import { DatePipe } from '@angular/common';
import { TovpilUtilsService } from 'src/app/utils/tovpil-utils.service';
import { ValuesVO } from 'src/app/shared/models/ValuesVO';
import { TovpilFilesService } from 'src/app/utils/tovpil-files.service';
import { TovpilLanguageService } from 'src/app/utils/tovpil-language.service';
import { Constants } from 'src/app/shared/vo/Constants';
import { ResponseFile } from 'src/app/shared/models/ResponseFile';

@Component({
  selector: 'app-schoolfpg',
  templateUrl: './schoolfpg.component.html',
  styleUrls: ['./schoolfpg.component.scss'],
  providers: [MessageService, ConfirmationService]
})


export class SchoolfpgComponent implements OnInit {

  /** Security */
  currentUser: any;
  security: SecurityDocument;
  displayModalStatus: boolean;
  commentsSelected: string;
  dateSelected: string;
  statusSelected: ValuesVO;
  statusList: ValuesVO[]
  SchoolTranStsList: ValuesVO[]

  /** Labels */
  translations: Record<string, string> = {};
  blocked: boolean = true;
  responseFile?: ResponseFile;

  /** School */
  lstSchoolsFpg: SchoolFpgDataVO[];
  schoolSelected: SchoolFpgDataVO;
  lstCols: { field: string; header: string; }[];
  dataParent: any;
  datePipe: DatePipe = new DatePipe('en-US');
  selStoreId: string;
  selStore: any;

  constructor(private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private apiService: ApiService,
    private router: Router,
    private tovpilUtils: TovpilUtilsService,
    private authenticationService: AuthenticationService,
    private translationService: TovpilLanguageService,
    private filesService: TovpilFilesService,) {
    this.initConfigs();

  }

  ngOnInit(): void {



    this.currentUser = this.authenticationService.currentUserValue;
    this.getSecurity();
  }



  /** GENERAL FUNCTIONS */

  /**
   * The function retrieves security data for the current user and then calls two other functions.
   */
  getSecurity() {
    this.apiService.findSecurityById({ "id": this.currentUser.tokenProfile }).then(
      data => {
        this.security = data;
        this.getTranslatedLabels();
        this.getAllSchoolFpg();
      });
  }

  /**
   * This function retrieves translations for a list of labels and updates the corresponding variables
   * with the translated values.
   */
  async getTranslatedLabels() {
    try {
      await this.translationService.getTranslatedLabels(this.security.language, this.security.region);
      this.translations = this.translationService.getLabels();
      // await this.getLanguages();
      this.getLstCols();;
    } catch (error) {
      console.error("An error occurred while getting translated labels:", error);
      this.messageService.add({ severity: 'warn', summary: 'Error', detail: `Error: ${this.translations.lbl_translation} ${this.translations.lbl_language}` });
      // Error al traer labels traducidos
    }
  }

  /**
   * The function sets the values of an array of objects representing columns for a table.
   */
  getLstCols() {
    this.lstCols = [
      { field: 'schoolFPG.schoolId', header: this.translations.lbl_id },
      { field: 'schoolFPG.year', header: this.translations.lbl_period },
      { field: 'schoolFPG.name', header: this.translations.lbl_church },
      { field: 'schoolFPG.guideName', header: this.translations.lbl_guide_imparts },
      { field: 'schoolFPG.planedDate', header: this.translations.lbl_planned_date },
      { field: 'storeName', header: this.translations.lbl_coordination },
      { field: 'options', header: "" },
    ];
  }

  /**
   * The function "goBack" closes the current window.
   */
  goBack() {
    try {
      let navigationExtras: NavigationExtras = {
        state: JSON.parse(JSON.stringify({
          selStore: Constants.selStore,
          itemsNavigation: Constants.itemsNavigation,
          module: 'catalogs',
          view: 'schoolfpg',
          forLevelId: 'L'
        }))
      };
      Constants.selStore = null;
      Constants.itemsNavigation = null;
      console.debug(navigationExtras);
      try {
        this.router.navigate(['/commons/lcSelector'], navigationExtras);

      } catch (navigationError) {
        console.error("An error occurred while navigating to coordination catalog details:", navigationError);
        this.handleError('Redirigir', 'Algo salio mal al redirigir.');
      }
    } catch (parseError) {
      console.error("An error occurred while parsing state to JSON:", parseError);
      this.handleError('Redirigir', 'Algo salio mal al redirigir-');
    }
  }



  /** CRUD FUNCTIONS */

  /**
   * The function retrieves workshop guides based on the guide ID using an API service in TypeScript.
   */
  getAllSchoolFpg() {
    this.blocked = true;
    //console.log(this.selStoreId);
    this.apiService.getAllSchoolFpg({
      // PENDIENTE FALLA SI SE AGREGA PERO APARECE EN REQUEST
      "storeId": this.selStoreId ? this.selStoreId : "000000000",
    }).then(
      data => {
        this.lstSchoolsFpg = data;
      }).catch(error => {
        console.error(error);
      }).finally(() => {
        setTimeout(() => {
          this.blocked = false;
        }, 1500);
      });
  }

  /**
   * This function displays a confirmation message to the user and deletes a workshop if the user
   * confirms the action.
   * @param {any} workshop - It is a parameter of type "any" that represents the workshop object that
   * needs to be deleted. This parameter is passed to the function "deleteSchoolFpg" which is
   * called when the user confirms the deletion.
   */
  deleteSchoolFpg(school: any) {
    this.confirmationService.confirm({
      message: this.translations.lbl_school_prep_guides + " " + this.translations.lbl_will_be_removed,
      header: this.translations.lbl_confirm + " " + this.translations.lbl_delete_record + " ?",
      icon: 'pi pi-exclamation-triangle',
      acceptButtonStyleClass: "p-button-danger",
      rejectButtonStyleClass: "p-button-info",
      acceptLabel: this.translations.lbl_yes,
      rejectLabel: this.translations.lbl_no,
      accept: () => {
        this.deleteSchoolFpgService(school);
      }
    });
  }

  /**
   * This function deletes a workshop service and displays a success or error message.
   * @param {any} schoolSelected - The parameter `workshopSelected` is an object that represents the
   * selected workshop to be deleted. It contains the `wrksId` property which is the ID of the workshop
   * to be deleted. The function `deleteSchoolFpgService` uses this parameter to create a `Form0WrpVO`
   */
  deleteSchoolFpgService(schoolSelected: any) {
    let school: SchoolFpgVO = {
      schoolId: schoolSelected != null ? schoolSelected.schoolFPG.schoolId : "",
      storeId: this.selStoreId,
      status: schoolSelected != null ? schoolSelected.schoolFPG.status : "N",
      churchId: schoolSelected.schoolFPG != null ? schoolSelected.schoolFPG.churchId : null,
      year: schoolSelected.schoolFPG != null ? schoolSelected.schoolFPG.selectedYear : null,
      period: schoolSelected.schoolFPG != null ? schoolSelected.schoolFPG.selectedPeriod : null,
      language: this.security.language,
      wrksId01: schoolSelected.schoolFPG != null ? schoolSelected.schoolFPG.wrks01 != null ? schoolSelected.schoolFPG.wrksId : "" : "",
      wrksId02: schoolSelected.schoolFPG != null ? schoolSelected.schoolFPG.wrks02 != null ? schoolSelected.schoolFPG.wrksId : "" : "",
      wrksId03: schoolSelected.schoolFPG != null ? schoolSelected.schoolFPG.wrks03 != null ? schoolSelected.schoolFPG.wrksId : "" : "",
    }

    let schoolRequest: SchoolFPGWrpVO = {
      schoolFPG: school,
      method: 'DELETE',
      language: this.security.language,
      userId: this.security.userId
    }
    this.apiService.crudSchoolFpg(schoolRequest).then(
      data => {

        if (data && data.status.trim() == 'OK') {
          this.messageService.add({ severity: 'success', summary: this.translations.lbl_delete_record, detail: this.translations.lbl_updated_data, life: 5000 });
          this.getAllSchoolFpg();
        } else {
          this.messageService.add({ severity: 'warn', summary: `${this.translations.lbl_internal_server_error}: ${data.errorMessage}`, detail: " ", life: 10000 });
        }

      }).catch(error => {
        console.error(error);
        this.messageService.add({ severity: 'warn', summary: `${this.translations.lbl_service}: ${error} /`, detail: `${this.translations.lbl_update} ${this.translations.lbl_service}: ${error}/`, life: 3000 });
      });


  }



  /** REDIRECT FUNCTIONS */

  /**
   * This function navigates to the workshop detail page with the selected workshop and security
   * information.
   * @param {any} school - This parameter is an object that represents the selected workshop. It is
   * passed as an argument to the function `openSchoolFpgDetail()`.
   */
  openSchoolFpgDetail(data: any) {
    let obj = {
      eppg: data,
      security: this.security
    }

    let navigationExtras: NavigationExtras = {
      state: JSON.parse(JSON.stringify(obj))
    }
    this.router.navigate(['/catalogs/eppgs/schoolfpgDetail'], navigationExtras);
  }

  /**
   * The function "openNewSchoolFpgDetail" opens a new workshop detail.
   */
  openNewSchoolFpgDetail() {
    this.openSchoolFpgDetail(null);
  }

  /**
   * This function navigates to the workshopsParticipant page with the selected workshop and security
   * information.
   * @param {any} school - This parameter is a variable that represents the selected workshop. It is
   * passed as an argument to the function `openSchoolFpgParticipant'()`.
   */
  openSchoolFpgParticipant(school: any) {
    let obj = {
      storeId: this.selStoreId ? this.selStoreId : null,
      eppg: school,
      security: this.security
    }
    let navigationExtras: NavigationExtras = {
      state: JSON.parse(JSON.stringify(obj))
    }
    this.router.navigate(['catalogs/eppgs/schoolfpgParticipant'], navigationExtras);
  }



  exportExcel() {
    this.blocked = true;
    if (this.lstSchoolsFpg === null) {
      this.messageService.add({
        severity: 'warn',
        summary: this.translations.lbl_no_records_found,
        life: 3000
      });
      this.blocked = false;
    } else if (this.lstSchoolsFpg.length < 1) {
      this.messageService.add({
        severity: 'warn',
        summary: `${this.translations.lbl_list} ${this.translations.lbl_no_valid}`,
        life: 3000
      });
      this.blocked = false;
    } else {
      const params = {
        "storeId": this.selStoreId ? this.selStoreId : null,
        "year": null,
        "period": null,
        "language": this.security.language,
      }

      // const filteredJSON = this.lstSchoolsFpg.map((item) => ({
      //   "AÑO": item.schoolFPG ? (item.schoolFPG.year || 'S/N') : 'S/N',
      //   "PERIODO": item.schoolFPG ? (item.schoolFPG.period || 'S/N') : 'S/N',
      //   "IGLESIA": item.schoolFPG ? (item.schoolFPG.name || 'S/N') : 'S/N',
      //   "GUIA_QUE_IMPARTE": item.guideName || 'S/N',
      //   "ESTATUS": item.statusName || 'S/N',
      //   "FECHA_PLANEADA": this.formatDate(item.schoolFPG ? item.schoolFPG.planedDate : 'S/N') || 'S/N',
      //   "COORDINACION": item.storeName || 'S/N'
      // }));
      // this.filesService.tovpilExportXLSX(filteredJSON, 'listSchools_');
      try {
        this.apiService.dwdSFPGSumaryXLS(params).then(
          data => {
            this.responseFile = data;
            const source = `data:application/octet-stream;base64,${this.responseFile.base64File}`;
            const link = document.createElement("a");
            link.href = source;
            link.download = this.responseFile.nameFile
            link.click();
            this.blocked = false;
          });
      } catch (error) {
        console.error("An error occurred while getting translated labels:", error);
        this.messageService.add({ severity: 'warn', summary: 'Error', detail: `Error: ` });
        this.blocked = false;
      }

    }
  }

  exportPdf() {
    if (this.lstSchoolsFpg === null) {
      this.messageService.add({
        severity: 'warn',
        summary: this.translations.lbl_no_records_found,
        life: 3000
      });
    } else if (this.lstSchoolsFpg.length < 1) {
      this.messageService.add({
        severity: 'warn',
        summary: `${this.translations.lbl_list} ${this.translations.lbl_is_not_valid}`,
        life: 3000
      });
    } else {
      const filteredJSON = this.lstSchoolsFpg.map((item) => ({
        "AÑO": item.schoolFPG ? (item.schoolFPG.year || 'S/N') : 'S/N',
        "PERIODO": item.schoolFPG ? (item.schoolFPG.period || 'S/N') : 'S/N',
        "IGLESIA": item.schoolFPG ? (item.schoolFPG.name || 'S/N') : 'S/N',
        "GUIA_QUE_IMPARTE": item.guideName || 'S/N',
        "ESTATUS": item.statusName || 'S/N',
        "FECHA_PLANEADA": this.formatDate(item.schoolFPG ? item.schoolFPG.planedDate : 'S/N') || 'S/N',
        "COORDINACION": item.storeName || 'S/N'
      }));


      const keysArray = filteredJSON.map((item) => Object.keys(item));
      const valuesArray = filteredJSON.map((item) => Object.values(item));

      this.filesService.tovpilExportPDF(keysArray[0], valuesArray, 'listSchools_');

    }
  }


  /**
   * This function formats a given date string into a specific format using the datePipe module in
   * TypeScript.
   * @param {string} dateString - A string representing a date in any valid format (e.g. "2021-10-15" or
   * "Oct 15, 2021").
   * @returns The function `formatDate` is returning a formatted date string in the format of
   * 'dd-MM-yyyy'. The input parameter `dateString` is being passed to the `datePipe.transform` method to
   * format the date. The formatted date string is then returned by the function.
   */
  formatDate(dateString: string) {

    const formattedDate = this.datePipe.transform(this.tovpilUtils.convertStringToDate(dateString), 'yyyy-MM-dd');
    return formattedDate;
  }
  showDialogStatus(schoolSel: any) {
    this.commentsSelected = null;
    this.dateSelected = this.tovpilUtils.dateToTovpilDateFormat(new Date());
    this.statusSelected = null;
    this.schoolSelected = schoolSel;
    this.getStatusTransitionRules();
    this.displayModalStatus = true;
  }
  updateStatus() {

    this.apiService.changeSchoolStatus({
      "language": this.security.language,
      "schoolId": this.schoolSelected.schoolFPG.schoolId,
      "status": this.statusSelected.valueId,
      "comments": this.commentsSelected,
      "currDate": this.tovpilUtils.dateToTovpilDate2(this.dateSelected),
      "userId": this.security.userId
    }).then(
      data => {

        if (data.status == 'OK') {
          this.getAllSchoolFpg();
          this.displayModalStatus = false;
          this.messageService.add({
            severity: 'success', summary: this.translations.lbl_updated_data, detail: '', life: 3000
          });

        } else {
          this.messageService.add({ severity: 'warn', summary: 'Error', detail: data.errorMessage, life: 9000 });
        }

      }).catch(error => {
        console.error(error);
        this.messageService.add({ severity: 'warn', summary: `${this.translations.lbl_change} ${this.translations.lbl_school} ${this.translations.lbl_status}: ${error} /`, detail: "Error " + error + "/", life: 3000 });
      });


  }
  getStatusTransitionRules() {
    this.apiService.getStatusTransitionRules({
      "language": this.security.language,
      "fieldId": "schStsReas",
      "fieldVal": this.schoolSelected.schoolFPG.status
    }).then(
      data => {
        this.SchoolTranStsList = data;
      });
  }
  initConfigs() {
    const navigation = this.router.getCurrentNavigation();
    this.dataParent = navigation?.extras?.state || {};
    //console.log(this.dataParent);
    if (this.dataParent) {
      const { security, selStore, selPeriod } = this.dataParent;
      if (!Constants.selStore) {
        Constants.selStore = selStore;
        Constants.itemsNavigation = this.dataParent?.itemsNavigation;
      }
      this.selStore = Constants.selStore;

      this.selStoreId = Constants.selStore.storeId;
    }
  }
  private handleError(summary: string, detail: string) {
    console.error("An error occurred while parsing.");
    this.messageService.add({
      severity: 'error',
      summary: summary,
      detail: detail,
      life: 5000
    });
  }
}
